import { FC } from "react";
import { useTranslation } from "react-i18next";

import { BulkActionsPanel } from "@ryde/controls";
import { LayoutRight, LayoutRightCrudContentStatic } from "@ryde/layout";
import { RideCrudModeKey } from "@ryde/shared";

import { useBulkOperationsRidesReportActions } from "./use-bulk-operations-rides-report-actions";

export const BulkOperationsRidesReportDrawer: FC = () => {
  const rideEntity = RideCrudModeKey.uiUnit;
  const { t } = useTranslation();
  const { actions, closeDrawer } = useBulkOperationsRidesReportActions();

  return (
    <LayoutRight
      headerTitle={t(`general.BULK_ACTIONS`)}
      showFooter={false}
      closeClick={closeDrawer}
      showBackgroundImage={false}
      entity={rideEntity}
    >
      <LayoutRightCrudContentStatic isFlush>
        <BulkActionsPanel actions={actions} />
      </LayoutRightCrudContentStatic>
    </LayoutRight>
  );
};
